import ErrorPageTemplate from '../../components/ErrorPageTemplate';
import { useLanguage } from '../../contexts/language';

const UnauthorizedPage = () => {
  const { t } = useLanguage();
  return (
    <ErrorPageTemplate
      errorText={t('error-pages.unauthorized.text')}
      description={t('error-pages.unauthorized.description')}
    />
  );
};


export default UnauthorizedPage;